import { Record, List } from 'immutable';

const customersCanvasUrl = APP_CONFIG.ccUrl;
const defaultValues = {
  id: null,
  description: '',
  name: '',
  templateId: null,
  templateName: null,
  templateSize: null,
  templateUrl: '',
  previewUrl: '',
  defaultLayout: false,
  categoryNum: null,
  menuitemsCategory: new List(),
  sizeTypeItemId: null,
  designTypeItemId: null,
  designTextVer: null
}

function formatCustomersCanvasUrl(path) {
  const index = path.indexOf('UserDataFolder');
  let url = path.substring(index);
  url = url.replace(/\\/g, '/');
  return `${ customersCanvasUrl }/${ url }`;
}

export default class DesignLayout extends Record(defaultValues, DesignLayout) {
  constructor(values) {
    super({
      ...values,
      templateUrl: values && values.templateUrl
                  ? formatCustomersCanvasUrl(values.templateUrl)
                  : defaultValues.templateUrl,
      previewUrl: values && values.previewUrl
                  ? formatCustomersCanvasUrl(values.previewUrl)
                  : defaultValues.previewUrl,
    });
  }

  static filterActiveLayoutByTemplateSize(designLayouts, templateSize) {
    return designLayouts.filter((layout) => {
      return layout.get('templateSize') && layout.get('templateSize') === templateSize;
    });
  }

  static getDesignLayoutById(designLayouts, id) {
    return designLayouts.find((layout) => {
      return layout.get('templateId') === id ? layout : undefined;
    });
  }

  static getLayoutSubstringContentName(design, pageIndex) {
    const layoutElementsList = {
      typeId: null,
      sizeId: null,
      templateContentFileId: null,
      selectedLayoutId: null,
      designTextVer: '',
      templateSize: '',
    };
    //Priority is updatedTemplateId,updatedContentName(Page Level)
    // > templateContentFileId,contentName(Page Level)
    // > templateContentId,contentName(Design Level)
    let contentName = design.getIn(['designPages', pageIndex, 'contentName']);
    let contentFileId = design.getIn(['designPages', pageIndex, 'templateContentFileId']);
    const updatedContentName = design.getIn(['designPages', pageIndex, 'updatedContentName']);
    const updatedContentFileId = design.getIn(['designPages', pageIndex, 'updatedTemplateId']);
    const designContentName = design.get('contentName');
    const designContentFileId = design.get('templateContentId');
    contentName = updatedContentFileId ? updatedContentName : (contentFileId ? contentName : designContentName);
    contentFileId = updatedContentFileId ? updatedContentFileId : (contentFileId ? contentFileId : designContentFileId);
    contentName = contentName.replace(/.st/, '');
    const bkgd_tmp = contentName.substring(contentName.indexOf('_') + 1);

    layoutElementsList.typeId = design.get('designTypeItemId');
    layoutElementsList.sizeId = design.get('sizeTypeItemId');
    layoutElementsList.selectedLayoutId = contentName.substring(0, contentName.indexOf('_'));
    layoutElementsList.designTextVer = bkgd_tmp.substring(0, bkgd_tmp.indexOf('_'));
    //contentName = 172_KM0018A_kids_menu_9x13_text_right, templateSize = ki
    layoutElementsList.templateSize = bkgd_tmp.substring(bkgd_tmp.indexOf('_') + 1, bkgd_tmp.indexOf('_') + 3);
    layoutElementsList.templateContentFileId = contentFileId;
    return layoutElementsList;
  }
}

export const DesignLayouts = (data) => {
  let designLayouts = new List();
  if(data) {
    data.forEach((value) => {
      designLayouts = designLayouts.push(new DesignLayout(value));
    });
  }
  return designLayouts;
};
